import React from 'react';
import { Button } from 'react-bootstrap';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faCalculator } from '@fortawesome/free-solid-svg-icons';

const FormSubmitButton = ({ handleSubmit, values, result, scoreType }) => {
  return (
    <div className="linkbutton-widget">
      <button
        className="link-button auto"
        onClick={handleSubmit}
        disabled={
          Object.keys(values).length === 0 || result?.status === 'pending'
        }
      >
        <i
          className="fas fa-calculator"
          title={I18n.t('icons.calculator')}
          aria-hidden="true"
        />
        &nbsp;{' '}
        {scoreType === 'TR'
          ? I18n.t('euro_smr_score_widget.show.determine_score_tr')
          : I18n.t('euro_smr_score_widget.show.determine_score_smr')}
      </button>
    </div>
  );
};

export default FormSubmitButton;
